
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesReturnItemsBOMGrid extends Serenity.EntityGrid<ECommSalesReturnItemsBOMRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesReturnItemsBOM'; }
        protected getDialogType() { return ECommSalesReturnItemsBOMDialog; }
        protected getIdProperty() { return ECommSalesReturnItemsBOMRow.idProperty; }
        protected getInsertPermission() { return ECommSalesReturnItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesReturnItemsBOMRow.localTextPrefix; }
        protected getService() { return ECommSalesReturnItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}